import React from 'react';
import { capitalizeFirstLetter, formatOrderDateToLocalTime } from '../../../util';
import { obfuscateSensitiveData } from '../../../util/formatUtil';
import { Row, TableData } from 'components/common/tableElements';
import * as sensitiveDataTypes from 'constants/sensitiveDataTypes';

const SimplrOrderSearchResult = ({ result, clickAction, even }) => {
  let orderStatus = result['orderStatus'] && capitalizeFirstLetter(result['orderStatus']);

  let name = '';
  const customer = result['customer'];
  if (customer) {
    const firstName = customer['firstName'] || '';
    const lastName =
      (!!customer['lastName'] && obfuscateSensitiveData(customer['lastName'], sensitiveDataTypes.lastName)) || '';
    if (firstName || lastName) {
      name = `${firstName} ${lastName}`;
    }
  }

  return (
    <Row onClick={(e) => clickAction(e, result)} hoverPointer={true} even={even}>
      <TableData>{result['orderId']}</TableData>
      <TableData>{formatOrderDateToLocalTime(result['createdAt'], 'simplrOrder')}</TableData>
      <TableData>{name}</TableData>
      <TableData>{orderStatus}</TableData>
    </Row>
  );
};

export default SimplrOrderSearchResult;
